module.exports = __webpack_public_path__ + "img/shakaplayer.d1633bb0.png";